import React from "react";
import { useTranslation } from "react-i18next";

const ICONS = {
    report: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
    ),
    search: (
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
    ),
};

const Spinner = () => (
    <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24" aria-hidden="true">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
    </svg>
);

/**
 * Primary action for report filter panels — matches Session Statement / Revenue reports.
 */
export default function ReportGenerateButton({
    onClick,
    disabled = false,
    loading = false,
    label,
    loadingLabel,
    icon = "report",
    className = "w-full h-[42px]",
}) {
    const { t } = useTranslation();
    const resolvedLabel = label ?? t("reports.common.generateReport");
    const resolvedLoadingLabel = loadingLabel ?? t("common.loading");

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled || loading}
            className={`px-6 py-2.5 rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold transition-all shadow-md hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 ${className}`}
        >
            {loading ? (
                <>
                    <Spinner />
                    {resolvedLoadingLabel}
                </>
            ) : (
                <>
                    {ICONS[icon] ?? ICONS.report}
                    {resolvedLabel}
                </>
            )}
        </button>
    );
}
